export const COMPANY_DOCUMENT_CATEGORY_LABELS = {
  quote: 'Devis',
  site_photos: 'Photos du chantier avant / après',
  reception_report: 'PV de réception',
  company_invoice: 'Facture entreprise',
  anah_funding_plan: 'Plan de financement ANAH signé',
  anah_balance_request: 'Demande de paiement ANAH signée',
  discharge_letter: 'Lettre de décharge',
};

export const isCompanyDocumentCategoryComplete = (category, documents) => {
  const received = documents.filter(document => document.received === true);
  return category === 'site_photos'
    ? ['before', 'after'].every(phase => received.some(document => document.photoPhase === phase))
    : received.length > 0;
};

export const isSharedCompanyDocumentCategory = (categories, category) =>
  categories.find(item => item.category === category)?.source === 'funding_documents';

export const getCompanyDocumentsCompletion = categories => {
  const keys = Object.keys(COMPANY_DOCUMENT_CATEGORY_LABELS).filter(
    category => categories.find(item => item.category === category)?.required !== false,
  );
  const count = keys.filter(category => {
    const item = categories.find(candidate => candidate.category === category);
    // A document shared by the dossier can be validated without a file (dossiers that had passed the step).
    return (
      item?.state === 'valid' || isCompanyDocumentCategoryComplete(category, item?.documents || [])
    );
  }).length;

  return {
    count,
    total: keys.length,
    state: count === keys.length ? 'complete' : 'pending',
    description: `${count} catégorie${count > 1 ? 's' : ''} déposée${count > 1 ? 's' : ''} sur ${
      keys.length
    }. Les photos avant et après chantier comptent ensemble.`,
  };
};
